<template>
  <div class="absolute top-full">
    <div data-testid="treeMenu" role="tree" class="flex flex-nowrap">
      <template v-if="data.noSideMenu">
        <template v-for="item in data.items">
          <template v-if="item.items">
            <template v-if="$storyblok.isVisible(item)">
              <HeaderNavbarDesktopTreeItem :key="item._uid" :data="item" />
            </template>
          </template>
        </template>
      </template>
      <template v-else>
        <!-- Panel 1 - Side Bar Menu -->
        <ul class="bg-gray-darkest rounded-bl min-w-[240px]">
          <template v-for="(item, index) in data.items">
            <template v-if="$storyblok.isVisible(item)">
              <!-- Relative is required for triangle to work. -->
              <li
                :id="`panel1-${item._uid}`"
                :key="item._uid"
                tabindex="0"
                role="treeitem"
                data-testid="treeMenuRootItem"
                class="relative font-bold text-light hover:bg-white hover:text-black focus-within:bg-white focus-within:text-black"
                v-bind="$storyblok.bindStoryblokBridgeData(item)"
                @touchstart.passive="showMenu(index)"
                @mouseenter="showMenu(index)"
                @mouseleave="clearTimer"
                @focus="showMenu(index)"
                @keyup.enter="focusPanel(`panel2-${item._uid}`)"
              >
                <div class="flex items-center justify-between pl-3 pr-5 py-4 cursor-default">
                  {{ item.text }}

                  <div
                    role="button"
                    aria-label="Expand menu"
                    tabindex="0"
                    class="w-3 h-3 focus:outline focus:outline-1 focus:outline-action"
                    @focus="showMenu(index)"
                    @keyup.enter.prevent="focusPanel(`panel2-${item._uid}`)"
                    @keydown.shift.tab.prevent="focusPanel(`panel1-${item._uid}`)"
                  >
                    <ArrowIcon class="w-3 h-3 transform -rotate-90 fill-current" />
                  </div>
                </div>
              </li>
            </template>
          </template>
        </ul>

        <!-- Panel 2 - Revealed subpanels -->

        <template v-for="(item, index) in data.items">
          <template v-if="item.items">
            <template v-if="$storyblok.isVisible(item)">
              <HeaderNavbarDesktopTreeItem
                v-show="activeMenuIndex === index"
                :key="item._uid"
                :is-active="activeMenuIndex === index"
                :data="item"
              />
            </template>
          </template>
        </template>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import ArrowIcon from '@/assets/arrow.svg?component'
const { $storyblok } = useNuxtApp()

const props = defineProps<{
  data: TreeMenu
  isActive: boolean
}>()

const activeMenuIndex = ref(-1)
watch(
  () => props.isActive,
  (newVal) => {
    activeMenuIndex.value = newVal ? 0 : -1
  }
)

let navHoverTimer: any
function clearTimer() {
  // If they mouseleave before the showMenu timer is done, clear it so we don't show it
  clearTimeout(navHoverTimer)
}

function showMenu(menuIndex: number) {
  clearTimeout(navHoverTimer)

  navHoverTimer = setTimeout(() => {
    activeMenuIndex.value = menuIndex
  }, 175)
}

function focusPanel(id: string) {
  const panel = document.getElementById(id)
  if (panel) panel.focus()
}
</script>
